export const SESSION_TAG = 'Session' as const
export const WISHLIST_TAG = 'Wishlist' as const
export const CART_TAG = 'Cart' as const
export const ASSET_TAG = 'Asset' as const
export const WO_STATUS_TAG = 'Status' as const
export const DELIVERY_NOTE_TAG = 'Delivery Note' as const
export const FILES_TAG = 'Files' as const

export type TagTypes =
  | typeof SESSION_TAG
  | typeof WISHLIST_TAG
  | typeof CART_TAG
  | typeof ASSET_TAG
  | typeof WO_STATUS_TAG
  | typeof DELIVERY_NOTE_TAG
  | typeof FILES_TAG
